import { LOCALE_ID, enableProdMode, importProvidersFrom } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi,
    withJsonpSupport,
} from '@angular/common/http';
import localeCs from '@angular/common/locales/cs';
import { MAT_CARD_CONFIG } from '@angular/material/card';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateCompiler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgChartsModule } from 'ng2-charts';
import { NgxMoveableModule } from 'ngx-moveable';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { APP_ROUTES } from './app/app-routes';
import { AppComponent } from './app/app.component';
import { PaginatorI18n } from './app/core/PaginatorI18n';
import { AuthHeaderInterceptor } from './app/interceptors/header.interceptor';
import { HttpErrorInterceptor } from './app/interceptors/http.interceptor';
import { LanguageInterceptor } from './app/interceptors/language.interceptor';
import { environment } from './environments/environment';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

registerLocaleData(localeCs);

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    // ./assets/i18n/ fix dev(staging) server on VPS & .htaccess
    return new TranslateHttpLoader(http, './assets/i18n/');
}

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(APP_ROUTES),
        importProvidersFrom(
            BrowserModule,
            NgChartsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            MatTableModule,
            MatPaginatorModule,
            MatSortModule,
            NgxMoveableModule,
            TourMatMenuModule
        ),
        { provide: LOCALE_ID, useValue: 'cs-CZ' }, // TODO: change by translation - možné řešení: https://github.com/armanozak/angular-dynamic-locale
        {
            provide: MatPaginatorIntl,
            deps: [TranslateService],
            useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl(),
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthHeaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
        /*{
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'fill' }
        }*/
        {
            provide: MAT_CARD_CONFIG,
            useValue: { appearance: 'outlined' },
        },

        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 500 } },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
        provideAnimations(),
        provideHttpClient(),
        {
            provide: TranslateCompiler,
            useClass: TranslateMessageFormatCompiler,
        },
    ],
}).catch((err) => console.error(err));
